// extracted by mini-css-extract-plugin
export default {"formWrapper":"CreateGroupModal_formWrapper__v1NRf"};